import { render, staticRenderFns } from "./refer-a-friend-discount-alert.vue?vue&type=template&id=48e0246c"
import script from "./refer-a-friend-discount-alert.vue?vue&type=script&lang=js"
export * from "./refer-a-friend-discount-alert.vue?vue&type=script&lang=js"
import style0 from "./refer-a-friend-discount-alert.vue?vue&type=style&index=0&id=48e0246c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports